// extracted by mini-css-extract-plugin
export var acitonButtons = "_am-0";
export var additionalIcon = "_am-f";
export var block = "_am-1";
export var blockContent = "_am-7";
export var blockDescription = "_am-8";
export var blockIcon = "_am-9";
export var blockTitle = "_am-6";
export var border = "_am-a";
export var center = "_am-l";
export var edge = "_am-b";
export var edgeLabel = "_am-c";
export var edgePath = "_am-d";
export var error = "_am-e";
export var flowchart = "_am-g";
export var flowchartContent = "_am-h";
export var highlighted = "_am-3";
export var hover = "_am-4";
export var icon = "_am-i";
export var left = "_am-m";
export var navButton = "_am-j";
export var navButtons = "_am-k";
export var right = "_am-n";
export var selected = "_am-2";
export var small = "_am-5";